import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'
import { CategoryId } from '~/models/category/types'

export const partsSearchConfig: SearchConfig = Object.freeze({
  settings: {
    searchName: 'parts',
    viewType: {
      defaultViewTypeDesktop: ViewType.GALLERY,
      defaultViewTypeMobile: ViewType.GALLERY
    },
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/query/',
      usesNuxtLinks: true
    },
    stats: {
      record: true
    },
    displayAds: true
  },
  rootParams: {
    category: [CategoryId.PARTS]
  }
})
